import { render } from "./AdminView.vue?vue&type=template&id=cdfa2f62&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=js"
export * from "./AdminView.vue?vue&type=script&lang=js"

import "./AdminView.vue?vue&type=style&index=0&id=cdfa2f62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdfa2f62"]])

export default __exports__